module.exports = __webpack_public_path__ + "static/media/2a-d2.5df049ff.JPG";